import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { DisruptionMessageRequest, DisruptionMessageResponse } from '../ridango.models';
import { MessageTypeService } from './message-type.service';
import Env from '../../env';
import { Temporal } from '@js-temporal/polyfill';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class AlertsService {
    constructor(
        private http: HttpClient,
        @Inject('ENV') private env: Env,
        private messageTypeService: MessageTypeService
    ) {}

    getAlerts({
        stopIds,
        routeIds,
        dateTime,
        tripHeadsign
    }: DisruptionMessageRequest = {}): Observable<DisruptionMessageResponse> {
        const url = `${this.env.WMB.WMB_PUBLIC_API}/v1/alerts`;
        let params = new HttpParams();
        if (stopIds?.length > 0) {
            params = params.append('stopId', stopIds.join(','));
        }
        if (routeIds?.length > 0) {
            params = params.append('routeId', routeIds.join(','));
        }
        if (tripHeadsign?.length > 0) {
            params = params.append('tripHeadsign', tripHeadsign.join(','));
        }
        if (dateTime) {
            const formattedDateTime = Temporal.Instant.fromEpochSeconds(dateTime).toString();
            params = params.append('dateTime', formattedDateTime);
        }
        return this.http.get<DisruptionMessageResponse>(url, { params }).pipe(
            map((response) => {
                response.messages = response?.messages?.map((message) => {
                    message.messageType ??= this.messageTypeService.determineMessageType(message);
                    return message;
                });
                response.messages = response.messages.sort((a, b) => {
                    if (!a.activePeriodStart && !b.activePeriodStart) {
                        return 0;
                    }
                    if (!a.activePeriodStart) {
                        return 1;
                    }
                    if (!b.activePeriodStart) {
                        return -1;
                    }
                    const dateA = new Date(a.activePeriodStart).getTime();
                    const dateB = new Date(b.activePeriodStart).getTime();
                    return dateB - dateA;
                });
                return response;
            })
        );
    }

    getRouteAlerts(routeId: string, fromTime?: number) {
        return this.getAlerts({ routeIds: [routeId], dateTime: fromTime });
    }

    getStopAlerts(stopId: string, fromTime?: number) {
        return this.getAlerts({ stopIds: [stopId], dateTime: fromTime });
    }
}
